const messages = {
  en: {
    ["connect"]: "Get started",
    ["connected"]: "Go to Quickbooks",
    ["accountSettings"]: "Account settings",
  },
  fr: {
    ["connect"]: "Commencer",
    ["connected"]: "Accéder à Quickbooks",
    ["accountSettings"]: "Paramètres du compte",
  },
};

export default messages;

